// extracted by mini-css-extract-plugin
export default {"root":"AddAddress_root__QfSTY","radio":"AddAddress_radio__TgDZ0","bottom_label":"AddAddress_bottom_label__stUyx","close":"AddAddress_close__Zu+d-"};